import { render } from "./ResponseTranslation.vue?vue&type=template&id=ef7191f2&scoped=true"
import script from "./ResponseTranslation.vue?vue&type=script&lang=js"
export * from "./ResponseTranslation.vue?vue&type=script&lang=js"

import "./ResponseTranslation.vue?vue&type=style&index=0&id=ef7191f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7191f2"]])

export default __exports__